import script from "./DepositosView.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositosView.vue?vue&type=script&setup=true&lang=js"

import "./DepositosView.vue?vue&type=style&index=0&id=50ee4b1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ee4b1c"]])

export default __exports__